module.exports = __webpack_public_path__ + "static/media/YDCH.94b00519.pdf";